export interface IMLLogMetadata {
    packageName?: string;
    packageVersion?: number;
    skillName?: string;
    skillVersion?: number;
}

export interface IMLLog {
    id: string;
    createdOn: Date;
    entityTypeName: MLEntityTypeName;
    severity: MLLogLevel;
    message: string;
    errorLog?: string;
    metadata?: IMLLogMetadata;
}

export enum MLEntityTypeName {
    MLPackage = 'ML_PACKAGE',
    MLSkill = 'ML_SKILL',
    MLService = 'ML_SERVICE',
}

export enum MLLogLevel {
    Info = 'INFO',
    Warn = 'WARN',
    Error = 'ERROR',
    Fatal = 'FATAL',
}
